import $ from "jquery";

$( document ).ready(function() {
    !function(e) {
        function t(r) {
            if (i[r])
                return i[r].exports;
            var n = i[r] = {
                exports: {},
                id: r,
                loaded: !1
            };
            return e[r].call(n.exports, n, n.exports, t),
                n.loaded = !0,
                n.exports
        }
        var i = {};
        return t.m = e,
            t.c = i,
            t.p = "/assets/updates/js/",
            t(0)
    }([function(e, t, i) {
        e.exports = i(1)
    }
        , function(e, t, i) {
            "use strict";
            function r(e) {
                return e && e.__esModule ? e : {
                    default: e
                }
            }
            var n = i(2)
                , o = r(n);
            i(4)(),
                $(document).ready(function() {
                    $(".e-video-player").each(function(e, t) {
                        return new o.default(t)
                    })
                })
        }
        , function(e, t, i) {
            "use strict";
            function r(e) {
                return e && e.__esModule ? e : {
                    default: e
                }
            }
            function n(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = function() {
                function e(e, t) {
                    for (var i = 0; i < t.length; i++) {
                        var r = t[i];
                        r.enumerable = r.enumerable || !1,
                            r.configurable = !0,
                        "value"in r && (r.writable = !0),
                            Object.defineProperty(e, r.key, r)
                    }
                }
                return function(t, i, r) {
                    return i && e(t.prototype, i),
                    r && e(t, r),
                        t
                }
            }()
                , a = i(3)
                , s = r(a)
                , l = function() {
                function e(t) {
                    n(this, e);
                    var i = $(t);
                    this.detail = t.querySelector(e.block.selector("detail")),
                        this.heading = t.querySelector(e.block.selector("heading")),
                        this.player = t.querySelector(e.block.selector("player")),
                        this.profile = t.querySelector(e.block.selector("profile")),
                        this.progress = t.querySelector(e.block.selector("progress")),
                        this.toggle = t.querySelector(e.block.selector("toggle")),
                        this.time = t.querySelector(e.block.selector("time")),
                        this.inputSearch = t.querySelector(e.block.selector("search")),
                        this.inputProfile = t.querySelector(e.block.selector("profiles")),
                        this.inputCountry = t.querySelector(e.block.selector("country")),
                        this.$playerWrapper = i.find(e.block.selector("player-wrapper")),
                        this.$toggle = $(this.toggle);
                    var r = $(".js-video__options li")
                        , o = [];
                    r.each(function() {
                        var e = $(this);
                        o.push({
                            data: e.attr("data-filter"),
                            item: e
                        })
                    }),
                        this.videos = o;
                    var a = this.profile.getBoundingClientRect();
                    this.bucket = i.attr("data-bucket"),
                        this.profileLeft = a.left,
                        this.profileWidth = a.width,
                        this.onChange = this.onChange.bind(this),
                        this.onPlayback = this.onPlayback.bind(this),
                        this.onProfileClick = this.onProfileClick.bind(this),
                        this.onProgress = this.onProgress.bind(this),
                        this.onToggleClick = this.onToggleClick.bind(this),
                        this.onSearch = this.onSearch.bind(this),
                        t.querySelector(e.block.selector("options")).addEventListener("change", this.onChange),
                        this.player.addEventListener("play", this.onPlayback),
                        this.player.addEventListener("pause", this.onPlayback),
                        this.toggle.addEventListener("click", this.onToggleClick),
                        this.profile.addEventListener("click", this.onProfileClick),
                        this.inputSearch.addEventListener("keyup", this.onSearch),
                        this.inputCountry.addEventListener("change", this.onSearch),
                        $(".js-video__profiles").change(this.onSearch)
                }
                return o(e, null, [{
                    key: "block",
                    get: function() {
                        return s.default.block("video")
                    }
                }]),
                    o(e, [{
                        key: "profileUrl",
                        value: function(e) {
                            return this.bucket + "/profiles/" + e.attr("data-profile_file")
                        }
                    }, {
                        key: "videoUrl",
                        value: function(e) {
                            return this.bucket + "/videos/" + e.attr("data-video_file")
                        }
                    }, {
                        key: "onSearch",
                        value: function() {
                            var e = this.inputSearch.value + " " + this.inputCountry.value
                                , t = []
                                , i = [];
                            $(".js-video__profiles:checked").each(function() {
                                e += " " + $(this).val()
                            }),
                                this.videos.filter(function(r) {
                                    var n = new RegExp(e.split("").join("[\\w\\W]*"),"i");
                                    return r.data.match(n) ? t.push(r.item) : i.push(r.item),
                                        !0
                                }),
                                $.each(t, function() {
                                    $(this).show()
                                }),
                                $.each(i, function() {
                                    $(this).hide()
                                })
                        }
                    }, {
                        key: "onChange",
                        value: function(t) {
                            var i = $(t.target).next()
                                , r = $(t.target);
                            this.player.src = this.videoUrl(r),
                                this.profile.src = this.profileUrl(r),
                                this.detail.innerText = i.find(e.block.selector("next-detail")).text(),
                                this.heading.innerText = i.find(e.block.selector("next-heading")).text(),
                                this.$playerWrapper.addClass(s.default.states.active),
                                this.$toggle.removeClass(s.default.states.playing)
                            console.log("onChange")
                        }
                    }, {
                        key: "onPlayback",
                        value: function() {
                            this.player.paused && this.timeout && window.clearTimeout(this.timeout),
                            this.player.paused || this.onProgress(),
                                this.$toggle.toggleClass(s.default.states.playing, !this.player.paused)
                        }
                    }, {
                        key: "onToggleClick",
                        value: function() {
                            this.player.paused ? this.player.play() : this.player.pause()
                        }
                    }, {
                        key: "onProgress",
                        value: function() {
                            var e = Math.floor(this.player.currentTime || 0)
                                , t = this.player.duration ? this.player.currentTime / this.player.duration : 0;
                            this.progress.style.transform = "translateX(" + 100 * t + "%)",
                                this.time.innerText = Math.floor(e / 60) + ":" + ("00" + e % 60).slice(-2),
                                this.timeout = window.setTimeout(this.onProgress, 500)
                        }
                    }, {
                        key: "onProfileClick",
                        value: function(e) {
                            if (this.player.duration) {
                                var t = (e.clientX - this.profileLeft) / this.profileWidth;
                                this.player.currentTime = Math.floor(t * this.player.duration),
                                this.player.paused && this.player.play()
                            }
                        }
                    }]),
                    e
            }();
            t.default = l
        }
        , function(e, t) {
            "use strict";
            e.exports = {
                states: {
                    active: "is-active",
                    fixed: "is-fixed",
                    hidden: "is-hidden",
                    loading: "is-loading",
                    playing: "is-playing"
                },
                block: function(e) {
                    if (!e)
                        throw new Error("Empty block name.");
                    return {
                        event: function(t) {
                            return e + ":" + t
                        },
                        selector: function(t) {
                            return ".js-" + e + (t ? "__" + t : "")
                        }
                    }
                }
            }
        }
        , function(e, t, i) {
            var r, n;
            !function(i, o) {
                r = [],
                    n = function() {
                        return i.svg4everybody = o()
                    }
                        .apply(t, r),
                    !(void 0 !== n && (e.exports = n))
            }(this, function() {
                /*! svg4everybody v2.1.9 | github.com/jonathantneal/svg4everybody */
                function e(e, t, i) {
                    if (i) {
                        var r = document.createDocumentFragment()
                            , n = !t.hasAttribute("viewBox") && i.getAttribute("viewBox");
                        n && t.setAttribute("viewBox", n);
                        for (var o = i.cloneNode(!0); o.childNodes.length; )
                            r.appendChild(o.firstChild);
                        e.appendChild(r)
                    }
                }
                function t(t) {
                    t.onreadystatechange = function() {
                        if (4 === t.readyState) {
                            var i = t._cachedDocument;
                            i || (i = t._cachedDocument = document.implementation.createHTMLDocument(""),
                                i.body.innerHTML = t.responseText,
                                t._cachedTarget = {}),
                                t._embeds.splice(0).map(function(r) {
                                    var n = t._cachedTarget[r.id];
                                    n || (n = t._cachedTarget[r.id] = i.getElementById(r.id)),
                                        e(r.parent, r.svg, n)
                                })
                        }
                    }
                        ,
                        t.onreadystatechange()
                }
                function i(i) {
                    function n() {
                        for (var i = 0; i < f.length; ) {
                            var s = f[i]
                                , l = s.parentNode
                                , c = r(l)
                                , u = s.getAttribute("xlink:href") || s.getAttribute("href");
                            if (!u && a.attributeName && (u = s.getAttribute(a.attributeName)),
                            c && u) {
                                if (o)
                                    if (!a.validate || a.validate(u, c, s)) {
                                        l.removeChild(s);
                                        var h = u.split("#")
                                            , y = h.shift()
                                            , v = h.join("#");
                                        if (y.length) {
                                            var b = d[y];
                                            b || (b = d[y] = new XMLHttpRequest,
                                                b.open("GET", y),
                                                b.send(),
                                                b._embeds = []),
                                                b._embeds.push({
                                                    parent: l,
                                                    svg: c,
                                                    id: v
                                                }),
                                                t(b)
                                        } else
                                            e(l, c, document.getElementById(v))
                                    } else
                                        ++i,
                                            ++g
                            } else
                                ++i
                        }
                        (!f.length || f.length - g > 0) && p(n, 67)
                    }
                    var o, a = Object(i), s = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/, l = /\bAppleWebKit\/(\d+)\b/, c = /\bEdge\/12\.(\d+)\b/, u = /\bEdge\/.(\d+)\b/, h = window.top !== window.self;
                    o = "polyfill"in a ? a.polyfill : s.test(navigator.userAgent) || (navigator.userAgent.match(c) || [])[1] < 10547 || (navigator.userAgent.match(l) || [])[1] < 537 || u.test(navigator.userAgent) && h;
                    var d = {}
                        , p = window.requestAnimationFrame || setTimeout
                        , f = document.getElementsByTagName("use")
                        , g = 0;
                    o && n()
                }
                function r(e) {
                    for (var t = e; "svg" !== t.nodeName.toLowerCase() && (t = t.parentNode); )
                        ;
                    return t
                }
                return i
            })
        }
    ]);
//# sourceMappingURL=site.js.map

});


